//https://vuejs.org/v2/guide/routing.html

//import DashboardLayout from "@/views/Layout/DashboardLayout.vue";
import SideNavigator from "@/views/Navigator/SideNavigator.vue";
import AuthLayout from "@/views/Layout/AuthLayout.vue";
import NotFoundPage from "@/views/GeneralViews/NotFoundPage.vue";
import ErrorPage from "@/views/GeneralViews/ErrorPage.vue";
import RestrictedPage from "@/views/GeneralViews/RestrictedPage.vue";
import initService from "../common/api-services/init-service";

const Home = () => import(/* webpackChunkName: "dashboard" */ "../views/Pages/Home/Dashboard.vue");
const default_home = () => import(/* webpackChunkName: "dashboard" */ "../views/Pages/Home/Dashboard_NoHome.vue");
const Search = () => import(/* webpackChunkName: "dashboard" */ "@/views/Pages/Search/SearchDashboard.vue");
const SimDetail = () => import(/* webpackChunkName: "dashboard" */ "@/views/Pages/SimDetail/SimDetail.vue");
const Reports = () => import(/* webpackChunkName: "dashboard" */ "@/views/Pages/Reports/ReportsDashboard.vue");
const RptTemplate = () => import(/* webpackChunkName: "dashboard" */ "@/views/Pages/Reports/RptTemplate.vue");

//User Profile
const User = () => import(/* webpackChunkName: "pages" */ "@/views/Pages/UserProfile/UserProfile.vue");
const Activity = () => import(/* webpackChunkName: "pages" */ "@/views/Pages/UserProfile/Activity.vue");
const ServerStatistics = () =>
	import(/* webpackChunkName: "pages" */ "@/views/Pages/UserProfile/Server-Statistics.vue");
const Settings = () => import(/* webpackChunkName: "pages" */ "@/views/Pages/UserProfile/Portal-Settings.vue");
const PortalSettings = () => import(/* webpackChunkName: "pages" */ "@/views/Pages/UserProfile/Portal-Settings.vue");
const Support = () => import(/* webpackChunkName: "pages" */ "@/views/Pages/UserProfile/Support.vue");

//Authorization
const Login = () => import(/* webpackChunkName: "pages" */ "@/views/Pages/Authentication/Login.vue");
const Register = () => import(/* webpackChunkName: "pages" */ "@/views/Pages/Authentication/Register.vue");
const Forgot = () => import(/* webpackChunkName: "pages" */ "@/views/Pages/Authentication/Forgot.vue");
const ResetPassword = () => import(/* webpackChunkName: "pages" */ "@/views/Pages/Authentication/Reset-Password.vue");
const NewPassword = () => import(/* webpackChunkName: "pages" */ "@/views/Pages/Authentication/New-Password.vue");
const Lock = () => import(/* webpackChunkName: "pages" */ "@/views/Pages/Authentication/Lock.vue");

//Troubleshooting [basic troubleshooting is Diameter]
const Troubleshooting = () =>
	import(
		/* webpackChunkName: "dashboard" */ "@/views/Pages/TroubleShooting/Diameter/Diameter-Dashboard.vue"
	);
const Diameter = () =>
	import(
		/* webpackChunkName: "dashboard" */ "@/views/Pages/TroubleShooting/Diameter/Diameter-Dashboard.vue"
	);
const Overwatch = () =>
	import(/* webpackChunkName: "dashboard" */ "@/views/Pages/TroubleShooting/Overwatch/OverwatchDashboard.vue");

const RFReports = () =>
	import(/* webpackChunkName: "dashboard" */ "@/views/Pages/TroubleShooting/RF-Reports/RF-Dashboard.vue");
const LocationCheck = () => import(/* webpackChunckName: "dashboard" */ "@/views/Pages/TroubleShooting/LocationCheck.vue");
const DiscrepancyCheck = () => import(/* webpackChunckName: "dashboard" */ "@/views/Pages/TroubleShooting/DiscrepancyCheck.vue");
const HlrReset = () => import(/* webpackChunckName: "dashboard" */ "@/views/Pages/TroubleShooting/HlrReset.vue");
const HlrRestart = () => import(/* webpackChunckName: "dashboard" */ "@/views/Pages/TroubleShooting/HlrRestart");
const CancelLocation = () => import(/* webpackChunckName: "dashboard" */ "@/views/Pages/TroubleShooting/CancelLocation.vue");
const GgsnSubscriberLookup = () => import(/* webpackChunckName: "dashboard" */ "@/views/Pages/TroubleShooting/GgsnSubscriberLookup");
const SmsMtQueue = () => import(/* webpackChunckName: "dashboard" */ "@/views/Pages/TroubleShooting/SmsMtQueue");
const SendSms = () => import(/* webpackChunckName: "dashboard" */ "@/views/Pages/TroubleShooting/SendSms");
const SmsRouterLogSearch = () => import(/* webpackChunckName: "dashboard" */ "@/views/Pages/TroubleShooting/SmsRouterLogSearch");
const SmsRoutes = () => import(/* webpackChunckName: "dashboard" */ "@/views/Pages/TroubleShooting/SmsRoutes");

//administration [ basic admin is only User Management]
const Administration = () =>
	import(/* webpackChunkName: "dashboard" */ "@/views/Pages/Administrator/UserManagement/User-Management.vue");
const ProductManagement = () =>
	import(/* webpackChunkName: "dashboard" */ "@/views/Pages/Administrator/ProductManagement/Product-Management.vue");
const InventoryManagement = () =>
	import(
		/* webpackChunkName: "dashboard" */ "@/views/Pages/Administrator/InventoryManagement/Inventory-Management.vue"
	);
const UserManagement = () =>
	import(/* webpackChunkName: "dashboard" */ "@/views/Pages/Administrator/UserManagement/User-Management.vue");
const DataManagement = () =>
	import(/* webpackChunkName: "dashboard" */ "@/views/Pages/Administrator/DataManagement/Data-Management.vue");
const TowerManagement = () =>
	import(/* webpackChunkName: "dashboard" */ "@/views/Pages/Administrator/TowerManagement/Tower-Management.vue");
const IFrame = () => import(/* webpackChunkName: "dashboard" */ "@/views/GeneralViews/IFramePage.vue");

const SimTool = () => import(/* webpackChunkName: "dashboard" */ "@/views/Pages/Administrator/SimTool.vue");

//eSim
const eSimSearch = () => import(/* webpackChunkName: "dashboard" */ "@/views/Pages/eSIM/eSimInventory.vue");
const eSimProfile = () => import(/* webpackChunkName: "dashboard" */ "@/views/Pages/eSIM/eSimProfile.vue");
const eSimQrcode = () => import(/* webpackChunkName: "dashboard" */ "@/views/Pages/eSIM/eSimQrcode.vue");
//const eSimOrder = () => import(/* webpackChunkName: "dashboard" */ "@/views/Pages/eSIM/eSimOrder.vue");
const eSimProfileReport = () => import(/* webpackChunkName: "dashboard" */ "@/views/Pages/eSIM/esimProfileReport.vue");
//const eSimOrderProfile = () => import(/* webpackChunkName: "dashboard" */ "@/views/Pages/eSIM/eSimOrderProfile.vue");
const eSimActivity = () => import(/* webpackChunkName: "dashboard" */ "@/views/Pages/eSIM/eSimActivity.vue");
const eSimBlacklist = () => import(/* webpackChunkName: "dashboard" */ "@/views/Pages/eSIM/eSimBlacklist.vue");
const eSimImport = () => import(/* webpackChunkName: "dashboard" */ "@/views/Pages/eSIM/eSimImport.vue");
const eSimCarrierAdmin = () => import(/* webpackChunkName: "dashboard" */ "@/views/Pages/eSIM/eSimCarrierAdmin.vue");

//OTA
const otaInventory = () => import(/* webpackChunkName: "dashboard" */ "@/views/Pages/OTA/otaInventory.vue");
const otaProfile = () => import(/* webpackChunkName: "dashboard" */ "@/views/Pages/OTA/otaProfile.vue");
const otaActivate = () => import(/* webpackChunkName: "dashboard" */ "@/views/Pages/OTA/otaActivate.vue");
const otaCarrier = () => import(/* webpackChunkName: "dashboard" */ "@/views/Pages/OTA/otaCarrier.vue");
const otaImport = () => import(/* webpackChunkName: "dashboard" */ "@/views/Pages/OTA/otaImport.vue");
const otaUsers = () => import(/* webpackChunkName: "dashboard" */ "@/views/Pages/OTA/otaUsers.vue");

//Entitlements
const entManager = () => import(/* webpackChunkName: "dashboard" */ "@/views/Pages/Entitlements/entitlementsManager.vue");

//CDMA
const cdmaRadcheck = () => import(/* webpackChunkName: "dashboard" */ "@/views/Pages/CDMA/cdmaRadcheck.vue");
const cdmaRadreply = () => import(/* webpackChunkName: "dashboard" */ "@/views/Pages/CDMA/cdmaRadreply.vue");
const cdmaRadusergroup = () => import(/* webpackChunkName: "dashboard" */ "@/views/Pages/CDMA/cdmaRadusergroup.vue");

//ENUM
const enumTool = () => import(/* webpackChunkName: "dashboard" */ "@/views/Pages/ENUM/enumTool.vue");

//HSS
const hssInventory = () => import(/* webpackChunkName: "dashboard" */ "@/views/Pages/HSS/hssInventory.vue");
const hssProfile = () => import(/* webpackChunkName: "dashboard" */ "@/views/Pages/HSS/hssProfile.vue");
const hssActivate = () => import(/* webpackChunkName: "dashboard" */ "@/views/Pages/HSS/hssActivate.vue");

// Sample
const samplePage = () => import("../views/Starter/NoDesign.vue");

const routes = [
	//Authorization
	{
		path: "/",
		redirect: "/login",
		component: AuthLayout,
		name: "Authentication",
		children: [
			{
				path: "/login",
				name: "login",
				component: Login,
			},
			{
				path: "/register",
				name: "Register",
				component: Register,
			},
			{
				path: "/forgot",
				name: "Forgot",
				component: Forgot,
			},
			{
				path: "/reset_password",
				name: "Reset Password",
				component: ResetPassword,
			},
			{
				path: "/new_password",
				name: "New Password",
				component: NewPassword,
			},
		],
	},

	{
		path: "/",
		component: SideNavigator,
		redirect: "home",
		name: "Dashboard",
		meta: {auth: true},
		children: [
			{
				path: "iframe",
				name: "iframe",
				component: IFrame,
			},

			{
				path: "default_home",
				name: "Welcome",
				component: default_home,
			},
			{
				path: "home",
				name: "Home",
				component: Home,
			},
			{
				path: "search",
				name: "Search",
				component: Search,
			},
			{
				path: "sim_detail/:id",
				name: "Sim Details",
				component: SimDetail,
			},

			//CDMA
			{
				path: "cdma/radcheck",
				name: "cdmaRadcheck",
				component: cdmaRadcheck,
			},
			{
				path: "cdma/radusergroup",
				name: "cdmaRadusergroup",
				component: cdmaRadusergroup,
			},
			{
				path: "cdma/radreply",
				name: "cdmaRadreply",
				component: cdmaRadreply,
			},

			//HSS
			{
				path: "hss/inventory",
				name: "hssInventory",
				component: hssInventory,
			},
			{
				path: "hss/profile",
				name: "hssProfile",
				component: hssProfile,
			},
			{
				path: "hss/activate",
				name: "hssActivate",
				component: hssActivate,
			},
			//  Strata, TelAlaska, ASTAC, CopperValley, Cambridge, CusterTel, Eagle, NNTC, Silverstar
			//OTA
			{
				path: "ota/inventory",
				name: "otaInventory",
				component: otaInventory,
			},

			{
				path: "ota/profile/:id",
				name: "otaProfile",
				component: otaProfile,
			},

			{
				path: "ota/activate/:id",
				name: "otaActivate",
				component: otaActivate,
			},
			{
				path: "ota/carrier_admin",
				name: "otaCarrier",
				component: otaCarrier,
			},
			{
				path: "ota/import",
				name: "otaImport",
				component: otaImport,
			},
			{
				path: "ota/user_admin",
				name: "otaUsers",
				component: otaUsers,
			},
			{
				path: "ota/records",
				name: "otaRecords",
				component: samplePage,
			},
			{
				path: "ota/batch",
				name: "otaBatch",
				component: samplePage,
			},
			{
				path: "ota/admin",
				name: "otaAdmin",
				component: samplePage,
			},
			{
				path: "help/ota",
				name: "otaHelp",
				component: samplePage,
			},
			{
				path: "entitlements",
				name: "entitlementManager",
				component: entManager,
			},

			//ESIM
			{
				path: "esim/inventory",
				name: "esimInventory",
				component: eSimSearch,
			},

			{
				path: "esim/profile/:id",
				name: "esimProfile",
				component: eSimProfile,
			},

			{
				path: "esim/qrcode/:id",
				name: "esimQrcode",
				component: eSimQrcode,
			},

			// {
			// 	path: "esim/order",
			// 	name: "esimOrderProfiles",
			// 	component: eSimOrder,
			// },

			{
				path: "esim/report",
				name: "eSimProfileReport",
				component: eSimProfileReport,
			},

			// {
			// 	path: "esim/order/:id",
			// 	name: "esimOrderProfile",
			// 	component: eSimOrderProfile,
			// },

			{
				path: "esim/activate",
				name: "esimActivity",
				component: eSimActivity,
			},

			{
				path: "esim/blacklist",
				name: "esimBlacklist",
				component: eSimBlacklist,
			},

			{
				path: "esim/import",
				name: "esimImport",
				component: eSimImport,
			},
			{
				path: "esim/carrier_admin",
				name: "eSimCarrierAdmin",
				component: eSimCarrierAdmin,
			},
			{
				path: "esim/records",
				name: "esimRecords",
				component: samplePage,
			},
			{
				path: "esim/batch",
				name: "esimBatch",
				component: samplePage,
			},
			{
				path: "esim/admin",
				name: "esimAdmin",
				component: samplePage,
			},
			{
				path: "esim/activate",
				name: "esimActivate",
				component: samplePage,
			},
			{
				path: "help/esim",
				name: "esimHelp",
				component: samplePage,
			},

			// ENUM
			{
				path: "enum/tool",
				name: "ENUM Tools",
				component: enumTool,
			},

			//REPORTS
			{
				path: "reports",
				name: "Reports",
				component: IFrame,
			},
			{
				path: "cordova_reports",
				name: "Cordova Reports",
				component: RptTemplate,
			},
			{
				path: "overwatch",
				name: "OverWatch",
				component: Overwatch,
			},
			{
				path: "diameter",
				name: "Diameter",
				component: Diameter,
			},
			{
				path: "rfreports",
				name: "RF Reports",
				component: RFReports,
			},
			{
				path: "enum",
				name: "ENUM Status",
				component: IFrame,
			},

			//Administration
			{
				path: "inventory_management",
				name: "Inventory Management",
				component: InventoryManagement,
			},
			{
				path: "/admin/user_admin",
				name: "User Management",
				component: UserManagement,
			},
			{
				path: "/admin/product_management",
				name: "Product Management",
				component: ProductManagement,
			},
			{
				path: "data_management",
				name: "Data Management",
				component: DataManagement,
			},
			{
				path: "tower_management",
				name: "Tower Management",
				component: TowerManagement,
			},
			{
				path: "api_docs",
				name: "API Docs",
				component: IFrame,
			},
			{
				path: "ims_kpi_graphing",
				name: "IMS KPI Graphing",
				component: IFrame,
			},
			{
				path: "ims_subscriber_status",
				name: "IMS Subscriber Status",
				component: IFrame,
			},
			{
				path: "aaa_log_download",
				name: "Download AAA Logs",
				component: IFrame,
			},
			{
				path: "sms_router_logs",
				name: "SMS Router Logs",
				component: IFrame,
			},
			{
				path: "aaa_log_search",
				name: "Search AAA Logs",
				component: IFrame,
			},
			{
				path: "broadband_graphs",
				name: "Broadband Graphs",
				component: IFrame,
			},
			{
				path: "roaming_heatmap",
				name: "Roaming Heatmap",
				component: IFrame,
			},
			// {
			// 	path: "sms_mt_queue",
			// 	name: "SMS MT Queue",
			// 	component: IFrame,
			// },
			{
				path: "sms_subscriber_tracing",
				name: "SMS Subscriber Tracking",
				component: IFrame,
			},
			{
				path: "serviceassurance",
				name: "Service Assurance",
				component: IFrame,
			},
			{
				path: "admin/simtool",
				name: "SimTool",
				component: SimTool,
			},

			// Troubleshooting
			{
				path: "/location_check",
				name: "Location Check",
				component: LocationCheck,
			},
			{
				path: "/discrepancy_check",
				name: "Discrepancy Check",
				component: DiscrepancyCheck,
			},
			{
				path: "/hlr_reset",
				name: "HLR Reset",
				component: HlrReset,
			},
			{
				path: "/hlr_restart",
				name: "HLR Restart",
				component: HlrRestart,
			},
			{
				path: "/cancel_location",
				name: "Cancel Location",
				component: CancelLocation,
			},
			{
				path: "/ggsn_subscriber_lookup",
				name: "GGSN Subscriber Lookup",
				component: GgsnSubscriberLookup,
			},
			{
				path: "/sms_mt_queue",
				name: "SMS MT Queue",
				component: SmsMtQueue,
			},
			{
				path: "/sms_router_log_search",
				name: "SMS Router Log Search",
				component: SmsRouterLogSearch,
			},
			{
				path: "/sms_routes",
				name: "SMS Routes",
				component: SmsRoutes,
			},
			{
				path: "/send_sms",
				name: "Send SMS",
				component: SendSms,
			},

			//profiles
			{
				path: "profile",
				name: "My profile",
				component: User,
			},
			{
				path: "activity",
				name: "Activity",
				component: Activity,
			},
			{
				path: "serverstatus",
				name: "Server Status",
				component: ServerStatistics,
			},
			{
				path: "settings",
				name: "Settings",
				component: Settings,
			},
			{
				path: "portal-settings",
				name: "Portal Settings",
				component: PortalSettings,
			},
			{
				path: "support",
				name: "Support",
				component: Support,
			},

			// Restricted
			{
				path: "restricted",
				name: "Restricted",
				component: RestrictedPage,
			},
		],
	},
	{
		path: "*",
		redirect: function () {
			if (initService.getUserRoles) {
				if (
					initService.getUserRoles().includes("Administrator") ||
					initService.getUserRoles().includes("OTA_ADMIN")
				) {
					return "/404";
				} else {
					return "/restricted";
				}
			}
		},
	},
	//Errors
	{
		path: "/",
		redirect: "/login",
		component: AuthLayout,
		name: "Error Layout",
		children: [
			{
				path: "/error",
				name: "Error",
				component: ErrorPage,
			},
			{
				path: "/404",
				name: "404",
				component: NotFoundPage,
			},
		],
	},
];

export default routes;
